//
// Generated class AccountingJournalLineFormulaTemplate
//

/// <reference path="AccountingJournalLineFormulaTemplate_ManagedObject.ts" />

class AccountingJournalLineFormulaTemplate extends AccountingJournalLineFormulaTemplate_ManagedObject
{

}
